const queryKeys = {
  COUNTRY_HISTORICAL: 'COUNTRY_HISTORICAL',
  ALL_COUNTRIES: 'ALL_COUNTRIES',
  TOTAL: 'TOTAL',
  ALL_HISTORICAL: 'ALL_HISTORICAL',
  TOTAL_COUNTRY: 'TOTAL_COUNTRY',
  TOTAL_COUNTRY_YESTERDAY: 'TOTAL_COUNTRY_YESTERDAY',
};

export default queryKeys;